var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManutencao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 345.87 373.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{fill:url(#Gradiente_sem_nome_5);}.cls-4{fill:url(#Gradiente_sem_nome_12);}.cls-5{fill:url(#Gradiente_sem_nome_12-2);}.cls-6{fill:url(#Gradiente_sem_nome_14);}.cls-7{fill:url(#Gradiente_sem_nome_14-2);}.cls-8{clip-path:url(#clip-path);}.cls-9{fill:#61bcbc;}.cls-10{fill:url(#Gradiente_sem_nome_13);}.cls-11{fill:#e3e3e3;}.cls-12,.cls-14{fill:#fff;}.cls-12{opacity:0.25;}.cls-13{fill:url(#Gradiente_sem_nome_9);}.cls-15{fill:#d4d4d4;mix-blend-mode:multiply;}.cls-16{fill:#de912e;}.cls-17{fill:#ef9348;}.cls-18{fill:#edc624;}.cls-19{fill:#f4db74;}.cls-20{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_5",
    x1: 179.57,
    y1: 224.42,
    x2: 179.57,
    y2: 25.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#bdc9d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#9cb7d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#84aacf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#75a2ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#709fcd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12",
    x1: 74.31,
    y1: 180.2,
    x2: 74.31,
    y2: 223.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61bcbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#58aaaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#519b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e9696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12-2",
    x1: -1118.1,
    y1: 179.62,
    x2: -1118.1,
    y2: 223.66,
    gradientTransform: "matrix(-1, 0, 0, 1, -875.31, 0)",
    xlinkHref: "#Gradiente_sem_nome_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14",
    x1: 283.74,
    y1: 223.66,
    x2: 283.74,
    y2: 191.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e9696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#519b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#58aaaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61bcbc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14-2",
    x1: 53.32,
    y1: 223.71,
    x2: 53.32,
    y2: 195.88,
    xlinkHref: "#Gradiente_sem_nome_14"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.41,223.71a133.9,133.9,0,0,0,267.06,0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_13",
    x1: 150.25,
    y1: 222.79,
    x2: 150.25,
    y2: 377.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#919191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afafaf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_9",
    x1: 152.68,
    y1: 184.79,
    x2: 152.68,
    y2: 223.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#72b89a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#70b597"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#629d84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#598e78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#568974"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1420.19,831.71a45,45,0,0,0,14.44-86.14,31.69,31.69,0,0,0,6.24-2.12,31,31,0,0,0-6.63-58.49,40.23,40.23,0,0,0-53.41-58.53,21.83,21.83,0,0,0-38.7-14.23,45.72,45.72,0,0,0-82.11-.92,56.31,56.31,0,0,0-79.43,78.29,53.5,53.5,0,0,0-5.75,2.26,52.54,52.54,0,0,0,5.67,97.59,37.29,37.29,0,0,0,37.67,58.12,26,26,0,0,0,45.61,17,45,45,0,0,0,89.17,5.6,45,45,0,0,0,67.23-38.43Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Prancheta 77") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M290.91,224.42V136.94a111.34,111.34,0,0,0-222.67,0v87.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M74.31,180.2h0A21.75,21.75,0,0,1,96.06,202v21.75a0,0,0,0,1,0,0H52.56a0,0,0,0,1,0,0V202A21.75,21.75,0,0,1,74.31,180.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M222.05,191.73h0a15.93,15.93,0,0,1,13.54,7.53,22,22,0,0,1,21.89-19.64h0a22,22,0,0,1,22,22v22H206.09v-16A16,16,0,0,1,222.05,191.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M296,202.8h0a10.44,10.44,0,0,0-3.8.73A15.91,15.91,0,0,0,261,207.76v15.9h45.47V213.23A10.43,10.43,0,0,0,296,202.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M53.32,195.88h0a13.91,13.91,0,0,1,13.91,13.91v13.91a0,0,0,0,1,0,0H39.41a0,0,0,0,1,0,0V209.79A13.91,13.91,0,0,1,53.32,195.88Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: -4.59,
    y: 222.79,
    width: 320.68,
    height: 154.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 65.74,
    y: 222.79,
    width: 169.02,
    height: 154.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 65.74,
    y: 222.79,
    width: 6.33,
    height: 154.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 234.76,
    y: 222.79,
    width: 6.33,
    height: 154.95
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M201.29,66.44h0A8.33,8.33,0,0,1,206.2,68v-.6a15.7,15.7,0,0,1,15.7-15.7h0a15.7,15.7,0,0,1,15.7,15.7v4.69a6.42,6.42,0,0,1,4.56-1.89h0a6.46,6.46,0,0,1,6.46,6.45v6.45H192.94V74.79A8.35,8.35,0,0,1,201.29,66.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M286.68,106.44c-.43,0-.86-.06-1.3-.06h0a19.92,19.92,0,0,0-19.93,19.92v.76a10.57,10.57,0,0,0-6.23-2h0a10.59,10.59,0,0,0-10.6,10.6v10.6h42.29v-9.29A111.23,111.23,0,0,0,286.68,106.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M131,100.44h0a6.4,6.4,0,0,1,3.8,1.24v-.46A12.17,12.17,0,0,1,147,89.05h0a12.17,12.17,0,0,1,12.17,12.17v3.63a5,5,0,0,1,3.54-1.47h0a5,5,0,0,1,5,5v5H124.56v-6.48A6.47,6.47,0,0,1,131,100.44Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 96.06,
    y: 184.79,
    width: 113.24,
    height: 38.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 99.78,
    y: 143.33,
    width: 10.17,
    height: 152.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 109.95,
    y: 143.33,
    width: 3.21,
    height: 152.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 195.92,
    y: 143.33,
    width: 10.17,
    height: 152.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 206.09,
    y: 143.33,
    width: 3.21,
    height: 152.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 99.78,
    y: 201.33,
    width: 13.38,
    height: 8.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 195.92,
    y: 201.33,
    width: 13.38,
    height: 8.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 81.3,
    y: 209.75,
    width: 145.33,
    height: 50.76,
    rx: 9.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 81.3,
    y: 151.38,
    width: 145.33,
    height: 50.76,
    rx: 9.84
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 99.78,
    y: 260.51,
    width: 13.38,
    height: 6.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 195.92,
    y: 260.51,
    width: 13.38,
    height: 6.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M109.25,151.38l-27.95,28v13a9.84,9.84,0,0,0,9.84,9.84h.91l50.75-50.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "216.34 151.38 216.34 151.38 182.79 151.38 132.04 202.14 165.59 202.14 216.34 151.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M91.14,209.75a9.83,9.83,0,0,0-9.84,9.84v31.07a9.84,9.84,0,0,0,9.84,9.85h59l50.76-50.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M216.78,260.51a9.85,9.85,0,0,0,9.85-9.85V219.59a9.94,9.94,0,0,0-.18-1.82l-42.74,42.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M216.78,209.75H200.92l-50.76,50.76h33.55l42.74-42.74A9.84,9.84,0,0,0,216.78,209.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M226.63,181.09l-21,21h11.2a9.85,9.85,0,0,0,9.85-9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M160.93,209.75H127.38L82.24,254.88h0a9.78,9.78,0,0,0,9.34,5.63h18.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 105.65,
    cy: 145.29,
    r: 11.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 105.65,
    cy: 145.29,
    r: 7.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 201.01,
    cy: 145.29,
    r: 11.47
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 201.01,
    cy: 145.29,
    r: 7.91
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManutencao);
export default __webpack_public_path__ + "static/media/manutencao.64a2d64dd390d83a617119d352d7552c.svg";
export { ForwardRef as ReactComponent };